import type { ManifestDoc, ManifestGroup } from '../config/manifest';

interface Props {
  group: ManifestGroup;
  doc: ManifestDoc;
}

export default function DocHeader({ group, doc }: Props) {
  const meta: { label: string; value: string }[] = [];
  if (doc.owner) meta.push({ label: 'Owner', value: doc.owner });
  if (doc.lastReviewed) meta.push({ label: 'Last reviewed', value: doc.lastReviewed });

  return (
    <header className="doc__header">
      <p className="doc__eyebrow">{group.title}</p>
      <h1 className="doc__title">{doc.title}</h1>
      {doc.subtitle && <p className="doc__subtitle">{doc.subtitle}</p>}
      {(doc.status || meta.length > 0) && (
        <div className="doc__meta">
          {doc.status && <span className={`status status--${doc.status}`}>{doc.status}</span>}
          {meta.map((m) => (
            <span key={m.label} className="meta__item">
              {m.label} · <strong>{m.value}</strong>
            </span>
          ))}
        </div>
      )}
    </header>
  );
}
